module.exports = __webpack_public_path__ + "static/media/workspaceCard.5b5942cc.svg";